import { mockData as workspacesData } from '@web/lib/demo/data/workspaces';
export var workspace = function () {
    return workspacesData[0];
};
